import { render, staticRenderFns } from "./UnterrichtBaseKnowledge.vue?vue&type=template&id=5dffbd10&scoped=true"
import script from "./UnterrichtBaseKnowledge.vue?vue&type=script&lang=ts"
export * from "./UnterrichtBaseKnowledge.vue?vue&type=script&lang=ts"
import style0 from "./UnterrichtBaseKnowledge.vue?vue&type=style&index=0&id=5dffbd10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dffbd10",
  null
  
)

export default component.exports